import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1f747d64")

_pushScopeId("data-v-1f747d64")
const _hoisted_1 = { class: "admin-footer" }
const _hoisted_2 = /*#__PURE__*/_createVNode("strong", null, [
  /*#__PURE__*/_createTextVNode("Copyright © 2020-2021 "),
  /*#__PURE__*/_createVNode("a", { href: "https://sgma.io" }, "sgma.io"),
  /*#__PURE__*/_createTextVNode(".")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" All rights reserved. ")
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "float-right d-none d-sm-inline-block" }, [
  /*#__PURE__*/_createVNode("b", null, "Version"),
  /*#__PURE__*/_createTextVNode(" 1.0.0")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("footer", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
})